import PageHeader from "@/components/PageHeader/PageHeader";
import PageWrapper from "@/components/PageWrapper/PageWrapper";
import AgentAgencyTabs from "./components/AgentAgencyTabs";

const Constria = () => {
  return (
    <PageWrapper className="admin-add-post">
      <PageHeader title="Travel Leaders Network > Profiles" />
      <AgentAgencyTabs />
    </PageWrapper>
  );
};

export default Constria;
